import { IonRow } from '@ionic/react';
import * as React from 'react';
import { useEffect, useState } from 'react';

import styles from '@/pages/ReportV2/components/CustomGraphComponents/CustomGraphComponents.module.css';

type VariabilityGraphLegendaProps = {
  legend: any;
};

export const VariabilityGraphLegenda = ({ legend }: VariabilityGraphLegendaProps) => {
  const [legendItems, setLegendItems] = useState<any>(legend);

  useEffect(() => {
    if (import.meta.env.MODE !== 'production') console.log('useEffect legend');
    setLegendItems(legend);

    return () => {
      if (import.meta.env.MODE !== 'production') console.log('useEffect legend cleanup');
    };
  }, [legend]);
  return (
    <>
      <div className=''>
        {legend.map((element: any, index: number) => {
          const color = element.color as string;
          const style = {
            backgroundColor: color,
          };
          if ('side' in element) {
            return (
              <IonRow className={styles.legend_entry} key={index}>
                <div className={styles.legend_dot} style={style} />
                {/* <div className='legend_dot' style={styles} /> */}
                <p className={styles.legend_name}>
                  {element.name} - {element.side}
                </p>
              </IonRow>
            );
          }
          return (
            <>
              <IonRow className={styles.legend_entry} key={index}>
                <div className={styles.legend_dot} style={style} />
                <p className={styles.legend_name}>{element.name}</p>
              </IonRow>
            </>
          );
        })}
      </div>
    </>
  );
};
